import React from 'react';
import { Settings, Users, FileCode, Database, Code2, Mail, Sliders } from 'lucide-react';

export type AdminTab = 'users' | 'database' | 'docs' | 'blog' | 'newsletter' | 'settings';

interface AdminTabHeaderProps {
  activeTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
}

export const AdminTabHeader: React.FC<AdminTabHeaderProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-4 border-b border-slate-200">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight flex items-center gap-2">
          <Settings className="w-5 h-5 text-indigo-600" />
          <span>Panel Administrator UIBN</span>
        </h2>
        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
          Kelola otorisasi akun pengguna, hak akses penerbit, serta pantau integrasi API sistem.
        </p>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap items-center gap-1.5 p-1 bg-slate-100/85 rounded-xl self-start md:self-auto border border-slate-200">
        <button
          onClick={() => onTabChange('users')}
          className={`px-3.5 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer ${
            activeTab === 'users'
              ? 'bg-white text-indigo-600 shadow-2xs border border-slate-200/40'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          <Users className="w-3.5 h-3.5" />
          <span>Kelola Pengguna</span>
        </button>

        <button
          onClick={() => onTabChange('blog')}
          className={`px-3.5 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer ${
            activeTab === 'blog'
              ? 'bg-white text-indigo-700 shadow-2xs border border-slate-200/40'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          <FileCode className="w-3.5 h-3.5 text-indigo-600" />
          <span>Kelola Blog</span>
        </button>

        <button
          onClick={() => onTabChange('database')}
          className={`px-3.5 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer ${
            activeTab === 'database'
              ? 'bg-white text-indigo-700 shadow-2xs border border-slate-200/40'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          <Database className="w-3.5 h-3.5 text-indigo-600" />
          <span>Backup & Restore DB</span>
        </button>

        <button
          onClick={() => onTabChange('docs')}
          className={`px-3.5 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer ${
            activeTab === 'docs'
              ? 'bg-white text-indigo-700 shadow-2xs border border-slate-200/40'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          <Code2 className="w-3.5 h-3.5" />
          <span>Dokumentasi API</span>
        </button>

        <button
          id="nav-tab-newsletter"
          onClick={() => onTabChange('newsletter')}
          className={`px-3.5 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer ${
            activeTab === 'newsletter'
              ? 'bg-white text-indigo-700 shadow-2xs border border-slate-200/40'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          <Mail className="w-3.5 h-3.5 text-indigo-600" />
          <span>Newsletter</span>
        </button>

        <button
          onClick={() => onTabChange('settings')}
          className={`px-3.5 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer ${
            activeTab === 'settings'
              ? 'bg-white text-indigo-700 shadow-2xs border border-slate-200/40'
              : 'text-slate-600 hover:text-slate-900'
          }`}
        >
          <Sliders className="w-3.5 h-3.5 text-indigo-600" />
          <span>Konfigurasi Sistem</span>
        </button>
      </div>
    </div>
  );
};
